import { taskItem } from './taskItem';
var _nestedNode = function nestedNode(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var result = [];
  node.forEach(function (item) {
    if (item.type.name === 'taskList') {
      result.push(_nestedNode(item, depth + 1));
    } else {
      result.push(taskItem(item, depth));
    }
  });
  return result.join('\n');
};
export var taskList = function taskList(node) {
  return _nestedNode(node);
};